import { render } from "./Heart.vue?vue&type=template&id=49a19c8b"
const script = {}

import exportComponent from "/var/www/ab-front-auth/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__